import { h, Component } from "preact";
import { css } from "emotion";
import Button from "../../components/Button";
import { Link } from "preact-router/match";
import { hexToRgba } from "../../utils/Format";

const styles = {
  wrapper: css`
    max-width: 1000px;
    max-height: 300px;
    height: 100%;
    display: flex;
    margin-top: 15px;
    margin-bottom: 15px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);
    @media (max-width: 1000px) {
      margin-right: 12px;
      margin-left: 12px;
    }
    @media (max-width: 600px) {
      flex-wrap: wrap;
      max-width: 100%;
      max-height: 100%;
      margin-top: 12px;
      margin-left: 1px;
      margin-right: 1px;
    }
  `,
  buttonContainer: css`
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    bottom: 39px;
    width: 130px;
    position: absolute;
    @media (max-width: 600px) {
      display: none;
    }
  `,
  link: css`
    text-decoration: none !important;
    color: inherit !important;
  `
};

/**
 * Display tiles view of featured events
 *
 * @param {*} props
 * @returns
 */
const FeaturedEventTilesView = props => {
  const {
    event,
    theme = {},
    showPrice,
    eventListingLayout = "eventTitle"
  } = props;

  const width = typeof screen !== "undefined" ? screen.width : null;
  let bannerImage =
    event.featureImage && event.featureImage.url
      ? event.featureImage.url
      : null;
  bannerImage =
    event.socialImage && event.socialImage.url
      ? event.socialImage.url
      : bannerImage;
  bannerImage =
    event.bannerImage && event.bannerImage.url
      ? event.bannerImage.url
      : bannerImage;
  const eventLink = `/${event.slug}`;
  const mobileEventLink = width < 600 ? eventLink : null;
  const eventTitle =
    eventListingLayout === "eventTitle"
      ? event.name
      : event.location.titleLocation;
  const eventInfo =
    eventListingLayout === "eventTitle"
      ? event.location.titleLocation
      : event.name;

  const customStyles = {
    image: css`
      max-width: 660px;
      width: 100%;
      height: 330px;
      background: url(${bannerImage}) center center / cover no-repeat
        rgb(238, 238, 238);
      @media (max-width: 700px) {
        max-width: 100%;
        padding-top: 50%;
        height: 146px;
      }
    `,
    rightCol: css`
      width: 100%;
      max-width: 340px;
      padding: 32px 24px;
      position: relative;
      background: ${hexToRgba(
        theme.eventCardBackgroundColor,
        theme.cardAndBarOpacity
      )};
      @media (max-width: 600px) {
        max-width: 100%;
        height: 118px;
        padding: 16px 12px;
      }
    `,
    title: css`
      font-size: 26px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 24px;
      white-space: nowrap;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? theme.cardTitleColor
        : "#ffffff"};
      @media (max-width: 600px) {
        font-size: 16px;
        margin-bottom: 4px;
      }
    `,
    contents: css`
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? theme.cardTitleColor
        : "#ffffff"};
      @media (max-width: 600px) {
        font-size: 14px;
      }
    `
  };

  return (
    <div className="featured-event-tile">
      <Link href={mobileEventLink} className={styles.link}>
        <div className={styles.wrapper}>
          <div className={customStyles.image} />
          <div className={customStyles.rightCol}>
            <div className={customStyles.title}>{eventTitle}</div>
            <div className={customStyles.contents}>
              {event.dates[0].display.combined}
            </div>
            <div className={customStyles.contents}>{eventInfo}</div>
            {showPrice ? (
              <div className={customStyles.contents}>
                {event.ticketsPriceStr}
              </div>
            ) : null}
            <div className={styles.buttonContainer}>
              <Link href={eventLink}>
                <Button
                  tourTheme={theme}
                  type="primary"
                  ariaLabel="Get Tickets"
                >
                  {theme.ticketButtonText}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default FeaturedEventTilesView;



// WEBPACK FOOTER //
// ./routes/tours/FeaturedEventTilesView.js